export const testimonials = [
  {
    id: 35,
    text: `Without you, my project wouldn't exist. Thank you.`,
    fontStyle: 'Trebuchet MS, Lucida Grande, sans-serif',
    fontSize: '2.5em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 36,
    text: `I've been thinking about our conversations.  You have brought so much light 
    into my life and I am so grateful to have met you.  You are so skilled at bringing 
    out the strengths in people and supporting those strengths. What a gift!`,
    fontStyle: 'Lucida Console, Monaco, monospace',
    fontSize: '1.2em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 37,
    text: `You unlocked some hidden strength within me that I didn't know I had.`,
    fontStyle: 'Georgia, sans-serif',
    fontSize: '1.8em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 38,
    text: `I got so much out of our session.  And I feel like I only scratched the 
    surface of what I want to work on.  Can't wait to connect again.`,
    fontStyle: 'Arial, Helvetica, sans-serif',
    fontSize: '1.8em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 39,
    text: `That was serious personal shifting going on.  I feel like you 
    are reintroducing me to myself.`,
    fontStyle: 'Geneva, Tahoma, sans-serif',
    fontSize: '1.8em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 40,
    text: `I know for an absolute fact and without a doubt that I am 1000% a 
    better artist, better person, better friend, better mother, because of you. 
    You have changed me in in so many ways. xx`,
    fontStyle: 'Lucida Console, Monaco, monospace',
    fontSize: '1.2em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 1,
    text: `You are an inspiration bomb and I'm so grateful for your insights. They are razor sharp 
      and have informed all of my writing.`,
    fontStyle: 'Georgia, sans-serif',
    fontSize: '1.8em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 2,
    text: `We spent $37k on test screenings... you gave us more useful information in one email 
      than those audiences combined. Thank you for reviewing our edit and for sharing such specific 
      notes. Just imagine what you could have saved us if we let you review the script before we 
      started shooting. Lesson learned. Thanks, my friend.`,
    fontStyle: 'Lucida Console, Monaco, monospace',
    fontSize: '1.2em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 3,
    text: `You gave me such insight... and I was so excited at the end of that call I wanted to 
      dive right in. Also, thank you for sharing your work and your ideas... I am INSPIRED!`,
    fontStyle: 'Arial, Helvetica, sans-serif',
    fontSize: '1.8em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 4,
    text: `You are the FIRST person I've sent the script to see if it's worth revisiting, possibly 
      with Netflix or Amazon, and it seems like you are on board. Which is enormously gratifying. 
      And thank you, again, for your thoughtfulness. Means a great deal to me.`,
    fontStyle: 'Geneva, Tahoma, sans-serif',
    fontSize: '1.6em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 5,
    text: `I still can't believe anyone wrote this to me. It is spectacular and so full of soul 
      recognition. I think it may be better written than the show. Thank you again.`,
    fontStyle: 'Lucida Console, Monaco, monospace',
    fontSize: '1.5em',
    fontWeight: 700,
    interval: 5000,
  },
  {
    id: 6,
    text: `I can't tell you how much I appreciate you and everything you said yesterday. I was 
      unraveling and unsure how I was going to get through all of this, and I suddenly feel okay 
      about everything. That was some pretty magical perspective you offered. I am so grateful. 
      Thank you so much. And thank you for zero judgement also. You are the TRUTH. I appreciate 
      you so much, Adrienne.`,
    fontStyle: 'Geneva, Tahoma, sans-serif',
    fontSize: '1.3em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 7,
    text: `Such a great save! How did we miss that?`,
    fontStyle: 'Trebuchet MS, Lucida Grande, sans-serif',
    fontSize: '2.5em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 8,
    text: `I've read and re-read your thoughts and I am GLOWING right now. I've shared this script 
      with very few people, largely because I don't give a flying f*** about what most people 
      would have to say about it. Your thoughts and words are REMARKABLE and I am grateful you 
      took the time and effort to articulate them to me. I'm going to keep reading your thoughts 
      all day long. They make me feel like I accomplished what I set out to do.`,
    fontStyle: 'Georgia, sans-serif',
    fontSize: '1.3em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 9,
    text: `You are amazing. This is so incredibly helpful. I have rewritten the second act of 
      this about five times in the last 72 hours and have no idea at this point is it made any 
      sense anymore or if I had just completely muddled the whole f***ing thing.`,
    fontStyle: 'Lucida Console, Monaco, monospace',
    fontSize: '1.4em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 10,
    text: `Wow! You are such an exquisitely intelligent, articulate, sophisticated, extraordinary 
      woman! I love these notes! And I adore you. You are so f***ing generous. And insightful.`,
    fontStyle: 'Didot, Palatino, serif',
    fontSize: '1.7em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 11,
    text: `Love you, Adrienne! Let's work together forever. You see it all the same way I see it. 
      Which, to me, is magic.`,
    fontStyle: 'Geneva, Tahoma, sans-serif',
    fontSize: '1.9em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 12,
    text: `I honestly can't thank you enough. You honestly made that scene work. Like it's 
      actually a GREAT SCENE. Thank you!`,
    fontStyle: 'Time New Roman, serif',
    fontSize: '1.9em',
    fontWeight: 700,
    interval: 5000,
  },
  {
    id: 13,
    text: `Wow. These thoughts are so, so valuable. Well done. Thank for putting them down, 
      perfect timing. I really appreciate it, Adrienne. Helpful to say the least. Know I am 
      truly impressed by your analytical skills and agree with so much of this.`,
    fontStyle: 'Verdana, sans-serif',
    fontSize: '1.4em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 14,
    text: `Grateful is actually, probably an understatement.`,
    fontStyle: 'Trebuchet MS, Lucida Grande, sans-serif',
    fontSize: '2.5em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 15,
    text: `Wow... well, Adrienne, I am humbled by your expedient 'reaction,' and your exquisitely 
      articulate attention to detail. And yes, so insightful you are. To see the characters 
      through your eyes, as teenagers, which is what they are, is refreshing... is so dead on. 
      Anyway, thank you, Adrienne... thank you so very much for all your intelligence, your time, 
      your perspective, and your enviable ability to spell out what it is you feel and see in the 
      piece. Thank you.`,
    fontStyle: 'Georgia, sans-serif',
    fontSize: '1.1em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 16,
    text: `You NAILED IT. Thank you, thank you, thank you.`,
    fontStyle: 'Lucida Console, Monaco, monospace',
    fontSize: '1.5em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 17,
    text: `Thank you so much for your input. I was really nervous to see your reaction since I've 
      never written anything like this. Wonderful notes!`,
    fontStyle: 'Didot, Palatino, serif',
    fontSize: '1.3em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 18,
    text: `Again, A... please know that I am deeply grateful for your sensitive and intelligent 
      perspective, and the time you've taken to share with me.`,
    fontStyle: 'Geneva, Tahoma, sans-serif',
    fontSize: '1.2em',
    fontWeight: 700,
    interval: 5000,
  },
  {
    id: 19,
    text: `Adrienne! Thank you! I'm so happy you loved it and felt it went unexpected places! It's 
      so hard when it lives in your head it really helps to have someone read it... Those are 
      great suggestions. I will absolutely look into highlighting the artist bit earlier and more 
      of the business stuff. Could be a very simple fix. Thank you, thank you!`,
    fontStyle: 'Times New Roman, serif',
    fontSize: '1.4em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 20,
    text: `Here's the thing. You have more brains than any actor I've ever met. You have more brain 
      than any producer I've ever met. You are extraordinarily generous. My life has honestly, 
      honestly, particularly my work life, benefitted by your energies, the way you pushed me and 
      Anahid to submit our goody little film and how you championed us, because EVERYBODY benefitted.`,
    fontStyle: 'Verdana, sans-serif',
    fontSize: '1em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 21,
    text: `Wonderful advice. Agree with everything you're saying. Thank you so, so much for this. 
      I'm going to reread over the next few days and start again.`,
    fontStyle: 'Trebuchet MS, Lucida Grande, sans-serif',
    fontSize: '1.4em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 22,
    text: `Wow. Lucky me to have you. Will fix!`,
    fontStyle: 'Georgia, sans-serif',
    fontSize: '1.5em',
    fontWeight: 700,
    interval: 5000,
  },
  {
    id: 23,
    text: `Man, u R such a rock star! All your notes help so much!!! I'll work on it. It all makes 
      great sense! XXOO`,
    fontStyle: 'Lucida Console, Monaco, monospace',
    fontSize: '1.3em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 24,
    text: `Oh my goodness... Thank you so much for the time... and wow, did you ever have great 
      foresight!`,
    fontStyle: 'Didot, Palatino, serif',
    fontSize: '2em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 25,
    text: `Yes, yes, YES. I am so happy you see it the same. I love your feedback, Adrienne, and I 
      am energized by it. Once again more dazzling on the inside than the outside-- no small feat.`,
    fontStyle: 'Geneva, Tahoma, sans-serif',
    fontSize: '1.3em',
    fontWeight: 400,
    interval: 5000,
  },
  {
    id: 26,
    text: `The answer is 'At least 16.' Yes again, your thoughts and words about my thoughts and 
      words blow me away. I am deeply grateful for the time and energy you put out to read, think 
      and write and I value every bit of it. It's arguably unfair that such a skilled actor is 
      also a skilled writer. I'd wish you'd pick one and quit showing off. I've only read your 
      email 3 times. How many more times will I read them tonight? See answer above.`,
    fontStyle: 'Times New Roman, serif',
    fontSize: '1.3em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 27,
    text: `Thank you so much for your notes!!! So helpful to get fresh eyes on it.`,
    fontStyle: 'Verdana, sans-serif',
    fontSize: '1.5em',
    fontWeight: 700,
    interval: 5000,
  },
  {
    id: 28,
    text: `Thank u thank u thank u thank u. That is a mere representation of my gratitude for you 
      and your thoughtful, intuitive, articulate words. Everything u wrote is exactly what I was 
      trying to accomplish-- creating more depth and tension within the family. So happy that 
      came through!`,
    fontStyle: 'Trebuchet MS, Lucida Grande, sans-serif',
    fontSize: '1.3em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 29,
    text: `Thank you very much for reading my script and diving deep into it and seeing all the 
      things I was trying to illuminate. I am truly touched by your response to it and how 
      intuitive you were picking up the important ideas what weren't written but hopefully 
      conveyed.`,
    fontStyle: 'Georgia, sans-serif',
    fontSize: '1.2em',
    fontWeight: 400,
    interval: 10000,
  },
  {
    id: 30,
    text: `You. Are. AMAZING!!! I knew you'd be able to do it. Wonderful!!!`,
    fontStyle: 'Verdana, sans-serif',
    fontSize: '1.5em',
    fontWeight: 700,
    interval: 5000,
  },
  {
    id: 31,
    text: `We were at a dead end. Your guidance made an enormous difference in reviving our film. Thank you.`,
    fontStyle: 'Didot, Palatino, serif',
    fontSize: '1.5em',
    fontWeight: 700,
    interval: 7000,
  },
  {
    id: 32,
    text: `Well, everyone loves your work! Easiest decision ever. LOL.`,
    fontStyle: 'Times New Roman, serif',
    fontSize: '1.5em',
    fontWeight: 700,
    interval: 5000,
  },
  {
    id: 33,
    text: `You are one of my favorite bright rays of light in this haphazard world of creativity we share. 
      I appreciate you so much.`,
    fontStyle: 'Trebuchet MS, Lucida Grande, sans-serif',
    fontSize: '1.3em',
    fontWeight: 400,
    interval: 7000,
  },
  {
    id: 34,
    text: `I love your passion and input. You managed in one email to break down what needs to be done, 
      how and why. I love the way you think!`,
    fontStyle: 'Georgia, sans-serif',
    fontSize: '1.3em',
    fontWeight: 400,
    interval: 7000,
  },
];
